import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Box, Typography } from "@mui/material";
const SectionTitle = ({ children, mt = 2, mb = 2, }) => (_jsxs(Box, Object.assign({ display: "flex", alignItems: "center", mt: mt, mb: mb }, { children: [_jsx(Box, { sx: {
                width: 4,
                height: 32,
                background: "var(--hemoes-section-title-accent)",
                borderRadius: 2,
                mr: 1.5,
            } }), _jsx(Typography, Object.assign({ variant: "h5", sx: {
                fontFamily: "Montserrat, sans-serif",
                fontWeight: 600,
                fontSize: "calc(32px + var(--accessibility-font-delta, 0px))",
                lineHeight: "46px",
                letterSpacing: "1px",
                verticalAlign: "middle",
                color: "var(--hemoes-section-title-text)",
            } }, { children: children }))] })));
export default SectionTitle;
